import { createReducer } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';
import t from '@/store/types';

const initialState: { data: Record<string, any> } = {
  data: {},
};

export default createReducer(initialState, (builder) => {
  builder.addCase(t.SET_PLAN_SUBSCRIPTIONS_LIST, (state, action: AnyAction) => {
    const { subscriptions } = action.payload;
    const _data: Record<string, any> = {};

    subscriptions.forEach((subscription: any) => {
      _data[subscription.id] = subscription;
    });
    state.data = _data;
  });
});
